// Copyright 2025-2026 Florian Gallon. All Rights reserved.
// Records when a user last opened the app (shown as "last connection" in admin)

import { db } from '../firebase';
import { doc, updateDoc } from 'firebase/firestore';

const MIN_INTERVAL_MS = 60 * 60 * 1000; // write at most once per hour

/**
 * Update users/{uid}.lastActiveAt, skipping the write if it was set within the last hour.
 * Never throws — activity tracking must not block login.
 * @param {string} uid - The user ID
 * @param {object} profile - The user's current profile data (to read lastActiveAt)
 */
export async function touchLastActive(uid, profile) {
  if (!uid) return;

  const last = profile?.lastActiveAt ? new Date(profile.lastActiveAt).getTime() : 0;
  if (last && Date.now() - last < MIN_INTERVAL_MS) return;

  try {
    await updateDoc(doc(db, 'users', uid), { lastActiveAt: new Date().toISOString() });
  } catch (error) {
    console.error('Failed to record last activity:', error);
  }
}
